// Application Version Configuration
// Update this file with each deployment
// Format: v{major}.{year}.{month}.{release}

export const APP_VERSION = 'v1.2026.2.2';
export const APP_BUILD_DATE = '2026-02-06';
